import { defineStore } from 'pinia'

export const useflightPlanState = defineStore('flightPlanState', {
  state: () => ({
    flightPlan: null,
    isFlightPlanRemoved: false
  }),
  actions: {
    setFlightPlan (flightPlan) {
      // replace entire modalForm with new object
      console.log('updating flight plan..')
      this.flightPlan = flightPlan
    },
    setIsFlightPlanRemoved (value) {
      console.log('value becomes true:', value)
      this.isFlightPlanRemoved = value
    }

  }
})
